import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Sparkles, X } from "lucide-react";
import { EarlyAccessForm } from "./EarlyAccessForm";

export const ComingSoonModal = ({ open, onOpenChange, source }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="early-access-modal"
      className="w-[calc(100%-1.5rem)] max-w-lg max-h-[92dvh] overflow-y-auto rounded-[2rem] border-0 bg-cream p-0 shadow-[0_40px_120px_-30px_rgba(18,52,90,0.55)] [&>button]:hidden"
    >
      <div className="relative h-32 overflow-hidden bg-navy sm:h-36">
        <div className="absolute -left-10 -top-10 h-40 w-40 rounded-full bg-teal/60 blur-2xl" />
        <div className="absolute bottom-0 right-0 h-32 w-32 rounded-full bg-gold/50 blur-2xl" />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="rotate-[-4deg] rounded-3xl bg-cream/95 p-3 shadow-xl animate-[floaty_5s_ease-in-out_infinite]">
            <img src="/images/logo-mark.webp" alt="" className="h-14 w-auto" />
          </div>
        </div>
        <button type="button" data-testid="early-access-modal-close" aria-label="Close" onClick={() => onOpenChange(false)} className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-cream transition-[background-color] hover:bg-white/25 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-teal/40">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="px-6 pb-7 pt-6 sm:px-9 sm:pb-9">
        <p className="eyebrow flex items-center gap-2"><Sparkles className="h-3.5 w-3.5" aria-hidden="true" /> Free early access</p>
        <DialogTitle className="mt-3 font-heading text-2xl font-extrabold leading-tight tracking-tight text-navy sm:text-3xl">
          Something wonderful is taking shape.
        </DialogTitle>
        <DialogDescription className="mt-3 text-base leading-relaxed text-navy/80">
          KeepThis! will help you preserve the memories without keeping the clutter. Join the early-access list and we'll let you know when it's ready.
        </DialogDescription>
        <div className="mt-6">
          <EarlyAccessForm source={source || "modal"} withName autoFocus />
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
